class MobileMenu {
  constructor() {
    this.menu = document.querySelector(".site-header__mobile-nav");
    this.toggleButton = document.querySelector(".mobile-nav__toggle");
    this.overlay = document.querySelector(".mobile-nav__overlay");
    this.events();
  }

  events() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", () => {
        if (this.menu.classList.contains("site-header__mobile-nav--active")) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      });
    }
  }

  closeMenu() {
    this.toggleButton.classList.add("fa-bars");
    this.toggleButton.classList.remove("fa-x");
    this.toggleButton.setAttribute("aria-expanded", "false");
    this.menu.classList.remove("site-header__mobile-nav--active");
    this.overlay.classList.remove("mobile-nav__overlay--active");
  }

  openMenu() {
    this.toggleButton.classList.remove("fa-bars");
    this.toggleButton.classList.add("fa-x");
    this.toggleButton.setAttribute("aria-expanded", "true");
    this.menu.classList.add("site-header__mobile-nav--active");
    this.overlay.classList.add("mobile-nav__overlay--active");
  }
}

export default MobileMenu;
